const onPersonViewPageMatch = async (pathname, regex) => {
  const personIdMatch = pathname.match(/\/view-person\/(\d+)/)
  const personId = personIdMatch ? personIdMatch[1] : null
  const previousPersonId = window.__impowerxPersonViewPersonId
  window.__impowerxPersonViewPersonId = personId

  if (!personId) {
    return
  }

  // After Speichern on edit-person, Impower SPA-navigates back to view-person without
  // remounting. Tear down our injects so they remount and refetch (no full page reload).
  const tearDownPersonViewInjects = () => {
    document
      .querySelectorAll(
        [
          '[data-impowerx-view-contact-options="true"]',
          '[data-impowerx-view-tax-exemption="true"]',
          '[data-impowerx-view-contact-substitution="true"]',
          '[data-impowerx-view-ehepartner="true"]',
          '[data-impowerx-view-contact-roles="true"]',
          '.impowerx-data-injected-container',
          '#ImpowerxNotificationsSettingsSection',
          '[data-lux-kontaktieren-via="view-value"]',
        ].join(',')
      )
      .forEach((el) => {
        if (el.getAttribute('data-lux-kontaktieren-via') === 'view-value') {
          el.remove()
          return
        }
        el.remove()
      })
    document.querySelectorAll('[data-lux-kontaktieren-via="view-impower-hidden"]').forEach((el) => {
      el.removeAttribute('data-lux-kontaktieren-via')
    })
    if (window.__luxKontaktierenViaViewApplied) {
      delete window.__luxKontaktierenViaViewApplied[personId]
    }
    if (window.__luxKontaktierenViaViewPending) {
      delete window.__luxKontaktierenViaViewPending[personId]
    }
    if (window.__luxContactOptionsViewCache) {
      delete window.__luxContactOptionsViewCache[personId]
    }
  }

  // Switching contacts in the SPA: drop previous person's Lux UI so we never flash stale prefs
  if (previousPersonId && String(previousPersonId) !== String(personId)) {
    document.querySelectorAll('[data-lux-kontaktieren-via="view-value"]').forEach((el) => el.remove())
    document.querySelectorAll('[data-lux-kontaktieren-via="view-impower-hidden"]').forEach((el) => {
      el.removeAttribute('data-lux-kontaktieren-via')
    })
    if (window.__luxKontaktierenViaViewPending) {
      delete window.__luxKontaktierenViaViewPending[previousPersonId]
    }
    // Bump fetch generation so in-flight responses for the previous person are ignored
    if (window.__luxKontaktierenViaViewFetchGen) {
      window.__luxKontaktierenViaViewFetchGen.value += 1
    }
  }

  if (String(window.__impowerxPersonViewNeedsRefresh || '') === String(personId)) {
    window.__impowerxPersonViewNeedsRefresh = null
    tearDownPersonViewInjects()
  }

  const formatDate = (value) => {
    if (!value) {
      return 'Nicht gesetzt'
    }

    const parsedDate = new Date(value)
    if (Number.isNaN(parsedDate.getTime())) {
      return 'Nicht gesetzt'
    }

    const day = String(parsedDate.getDate()).padStart(2, '0')
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
    const year = parsedDate.getFullYear()
    return `${day}.${month}.${year}`
  }

  const renderSectionState = (
    section,
    { substituteLabel = 'Nicht gesetzt', activeFromLabel = 'Nicht gesetzt', activeUntilLabel = 'Nicht gesetzt', note = '' } = {}
  ) => {
    const substituteValue = section.querySelector('[data-field-name="substituteContactValue"]')
    const activeFromValue = section.querySelector('[data-field-name="substituteActiveFromValue"]')
    const activeUntilValue = section.querySelector('[data-field-name="substituteActiveUntilValue"]')
    const noteElement = section.querySelector('[data-field-name="substituteNote"]')

    if (substituteValue) {
      substituteValue.textContent = substituteLabel
    }
    if (activeFromValue) {
      activeFromValue.textContent = activeFromLabel
    }
    if (activeUntilValue) {
      activeUntilValue.textContent = activeUntilLabel
    }
    if (noteElement) {
      noteElement.textContent = note
    }
  }

  const loadSubstitutionData = async (section, currentContactId) => {
    try {
      const authData = JSON.parse(localStorage.getItem('auth') || '{}')
      const token = authData.token

      if (!token) {
        renderSectionState(section, {
          substituteLabel: 'Nicht verfuegbar',
          activeFromLabel: 'Nicht verfuegbar',
          activeUntilLabel: 'Nicht verfuegbar',
          note: 'Nicht verfügbar',
        })
        return
      }

      const substitutionResponse = await fetch(
        `${baseApiUrl}/api/impowerX/contacts/substitution?contactId=${currentContactId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )

      if (!document.body.contains(section) || section._contactId !== currentContactId) {
        return
      }

      if (!substitutionResponse.ok) {
        renderSectionState(section, {
          substituteLabel: 'Fehler beim Laden',
          activeFromLabel: 'Fehler beim Laden',
          activeUntilLabel: 'Fehler beim Laden',
          note: 'Vertretungsdaten konnten nicht geladen werden.',
        })
        return
      }

      const substitutionData = await substitutionResponse.json()
      const substitution = substitutionData?.substitution

      if (!substitution) {
        renderSectionState(section, {
          substituteLabel: 'Nicht gesetzt',
          activeFromLabel: 'Nicht gesetzt',
          activeUntilLabel: 'Nicht gesetzt',
          note: '',
        })
        return
      }

      const contactsData = await getImpowerXData(`${baseApiUrl}/api/impowerX/contacts`).catch(() => ({}))
      const contacts = Array.isArray(contactsData?.contacts) ? contactsData.contacts : []
      const substituteId = String(substitution.substituteId || '')
      const selectedContact = contacts.find((contact) => String(contact?.id) === substituteId)
      const fullName = `${selectedContact?.firstName || ''} ${selectedContact?.lastName || ''}`.trim()
      const substituteLabel =
        selectedContact?.companyName ||
        fullName ||
        (substituteId ? `Kontakt ${substituteId}` : 'Nicht gesetzt')

      renderSectionState(section, {
        substituteLabel,
        activeFromLabel: formatDate(substitution.activeFrom),
        activeUntilLabel: formatDate(substitution.activeUntil),
        note: '',
      })
    } catch (error) {
      if (!document.body.contains(section)) {
        return
      }
      renderSectionState(section, {
        substituteLabel: 'Fehler beim Laden',
        activeFromLabel: 'Fehler beim Laden',
        activeUntilLabel: 'Fehler beim Laden',
        note: 'Beim Laden der Substitutionsdaten ist ein Fehler aufgetreten.',
      })
    }
  }

  const initializeSubstitutionSection = () => {
    const currentContactId = window.location.pathname.match(/\/persons\/view-person\/(\d+)/)?.[1]
    if (!currentContactId) {
      return false
    }

    const companyDataSection = document.querySelector('.CompanyData.component')
    if (!companyDataSection || !companyDataSection.parentNode) {
      return false
    }

    const existingSection = document.querySelector('[data-impowerx-view-contact-substitution="true"]')
    if (existingSection) {
      const isSameContact = existingSection._contactId === currentContactId
      if (isSameContact && document.body.contains(existingSection)) {
        return true
      }
      existingSection.remove()
    }

    const substitutionSection = document.createElement('div')
    substitutionSection.className = 'CompanyData component impowerx-contact-substitution'
    substitutionSection.dataset.impowerxViewContactSubstitution = 'true'
    substitutionSection._contactId = currentContactId
    substitutionSection.innerHTML = `
      <style data-field-name="viewContactSubstitutionStyle">
        .impowerx-contact-substitution {
          margin-top: 12px;
        }
        .impowerx-contact-substitution .title {
          margin-bottom: 10px;
        }
        .impowerx-contact-substitution-content {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
          row-gap: 6px;
        }
        .impowerx-contact-substitution-item {
          box-sizing: border-box;
          flex: 0 0 calc((100% - 32px) / 3);
          max-width: calc((100% - 32px) / 3);
        }
        .impowerx-contact-substitution-value {
          word-break: break-word;
        }
        .impowerx-contact-substitution-note {
          margin-top: 8px;
          color: rgba(0, 0, 0, 0.55);
        }
      </style>
      <div class="title impowerx-contact-substitution-title">Vertretung</div>
      <div class="impowerx-contact-substitution-content">
        <div class="basic-info section impowerx-contact-substitution-item">
          <div class="label impowerx-contact-substitution-label">KONTAKT</div>
          <div class="value impowerx-contact-substitution-value" data-field-name="substituteContactValue">Lade...</div>
        </div>
        <div class="basic-info section impowerx-contact-substitution-item">
          <div class="label impowerx-contact-substitution-label">AKTIV AB</div>
          <div class="value impowerx-contact-substitution-value" data-field-name="substituteActiveFromValue">Lade...</div>
        </div>
        <div class="basic-info section impowerx-contact-substitution-item">
          <div class="label impowerx-contact-substitution-label">AKTIV BIS</div>
          <div class="value impowerx-contact-substitution-value" data-field-name="substituteActiveUntilValue">Lade...</div>
        </div>
      </div>
      <div class="impowerx-contact-substitution-note" data-field-name="substituteNote"></div>
    `

    companyDataSection.parentNode.insertBefore(substitutionSection, companyDataSection)
    loadSubstitutionData(substitutionSection, currentContactId)
    return true
  }

  const injectPersonId = async () => {

    const dataCard = document.querySelector('.ant-card.data-card')
    if (!dataCard) {
      return false
    }

    let container = document.querySelector('.impowerx-data-injected-container')
    const contactIdFromContainer = container?.getAttribute('impowerx-data-contact-id')
    const contactID=window.__impowerxPersonViewPersonId

    if(contactIdFromContainer !== undefined && contactIdFromContainer !== contactID) {
      // Contact ID has changed, reload the page
      // this is to prevent data leak from previous contact
      window.location.reload()
    }

    // Find the Notiz label in the address-info section
    const labels = dataCard.querySelectorAll('.label')
    let notizLabel = null
    labels.forEach((label) => {
      if (label.textContent.trim() === 'Notiz') {
        notizLabel = label
      }
    })

    if (!notizLabel) {
      return false
    }

    // The value div is typically the next sibling of the label
    const notizValue = notizLabel.nextElementSibling
    if (!notizValue) {
      return false
    }
    const attributes = ['debitorennummer', 'kreditorennummer']

    if(container){
      return false
    }
    container = document.createElement('div')
    container.className = 'impowerx-data-injected-container'
    container.setAttribute('impowerx-data-contact-id', contactID)
    notizValue.insertAdjacentElement('afterend', container)
    const valuesFromImpowerX = await fetch(`${baseApiUrl}/api/impowerX/contacts/${contactID}?attributes=${attributes.join(',')}`
      , {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const valuesFromImpowerXData = await valuesFromImpowerX.json()
    const attributesData = valuesFromImpowerXData?.attributes
    // Create Kreditorennummer label and value, matching the existing structure
    attributes.forEach(attribute => {
      const attributeData = attributesData?.find(item => item.fieldName === attribute)
      const fieldLabel = document.createElement('div')
      fieldLabel.className = 'label'
      fieldLabel.textContent = attribute
      
      const fieldValue = document.createElement('div')
      fieldValue.className = 'value'
      fieldValue.textContent = attributeData?.value || personId
      fieldValue.setAttribute('impowerx-data-injected', attribute)

      // Insert after the Notiz value div
      container.appendChild(fieldLabel)
      container.appendChild(fieldValue)
    })
    return true
  }

  const NOTIFICATIONS_SECTION_ID = 'ImpowerxNotificationsSettingsSection'

  const NOTIFICATIONS_BELL_SVG = `
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 20a2.4 2.4 0 0 0 2.4-2.4H6.6A2.4 2.4 0 0 0 9 20Zm7.2-6V8.4c0-3.69-1.98-6.78-5.4-7.6V0H7.2v.8C3.78 1.62 1.8 4.71 1.8 8.4V14L0 15.8v.9h18v-.9L16.2 14Z" fill="currentColor"/>
    </svg>
  `

  const NOTIFICATION_SETTING_DEFINITIONS = [
    { key: 'all', label: 'E-Mail-Benachrichtigungen aktivieren', isChild: false },
    { key: 'statusChanges', label: 'E-Mail Benachrichtigung für Statusänderungen', isChild: true },
    { key: 'newUploadedDocuments', label: 'E-Mail-Benachrichtigungen für neue hochgeladene Dokumente', isChild: true },
    { key: 'phaseChanges', label: 'E-Mail Benachrichtigung für Phasenänderungen', isChild: true },
  ]

  const NOTIFICATIONS_DEFAULT_SETTINGS = {
    all: true,
    statusChanges: true,
    newUploadedDocuments: true,
    phaseChanges: false,
  }

  const injectNotificationsSectionStyles = () => {
    if (document.getElementById('impowerx-notifications-section-style')) return
    const style = document.createElement('style')
    style.id = 'impowerx-notifications-section-style'
    style.textContent = `
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-body {
        padding: 0px 24px 24px;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-status {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.55);
        margin-bottom: 12px;
        min-height: 18px;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-status.is-error {
        color: #ff4d4f;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 0;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-row.is-child {
        padding-left: 24px;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch {
        position: relative;
        display: inline-block;
        flex: 0 0 auto;
        width: 44px;
        height: 24px;
        cursor: pointer;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #d9d9d9;
        transition: background-color 0.2s;
        border-radius: 24px;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-slider::before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: transform 0.2s;
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch input:checked + .impowerx-notifications-slider {
        background-color: #1a1a1a;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch input:checked + .impowerx-notifications-slider::before {
        transform: translateX(20px);
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch.is-readonly,
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch.is-readonly .impowerx-notifications-slider {
        cursor: default;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch.is-disabled {
        cursor: not-allowed;
      }
      #${NOTIFICATIONS_SECTION_ID} .impowerx-notifications-switch.is-disabled .impowerx-notifications-slider {
        opacity: 0.5;
        cursor: not-allowed;
      }
    `
    document.head.appendChild(style)
  }

  const initializeNotificationsSettingsSection = () => {
    const currentContactId = window.location.pathname.match(/\/persons\/view-person\/(\d+)/)?.[1]
      || window.location.pathname.match(/\/view-person\/(\d+)/)?.[1]
    if (!currentContactId) return false

    const formSection =
      document.querySelector('.form-content > .form-section') ||
      document.querySelector('.overlay-page .form-content > .form-section')
    if (!formSection) return false

    const referenceSection =
      formSection.querySelector(':scope > #PropertySection') ||
      formSection.querySelector(':scope > .FormSection:last-of-type')
    if (!referenceSection) return false

    const existingSection = document.getElementById(NOTIFICATIONS_SECTION_ID)
    if (existingSection) {
      if (existingSection._contactId === currentContactId && document.body.contains(existingSection)) {
        return true
      }
      existingSection._abortController?.abort()
      existingSection.remove()
    }

    injectNotificationsSectionStyles()

    const section = document.createElement('div')
    section.className = 'FormSection '
    section.id = NOTIFICATIONS_SECTION_ID
    section.dataset.testid = `section-${NOTIFICATIONS_SECTION_ID}`
    section._contactId = currentContactId

    section.innerHTML = `
      <div class="form-section-wrapper ">
        <div class="main-section-header section-header not-open" data-testid="section-${NOTIFICATIONS_SECTION_ID}-toggle">
          <div class="section-number-box  ">
            <span role="img" class="anticon section-number">${NOTIFICATIONS_BELL_SVG}</span>
          </div>
          <div class="section-title-box ">
            <div class="section-title">Benachrichtigungseinstellungen</div>
          </div>
        </div>
      </div>
    `

    const sectionWrapper = section.querySelector('.form-section-wrapper')
    const sectionHeader = section.querySelector('.main-section-header.section-header')
    const sectionNumberBox = section.querySelector('.section-number-box')
    const sectionTitleBox = section.querySelector('.section-title-box')

    const abortController = new AbortController()
    section._abortController = abortController

    let currentSettings = { ...NOTIFICATIONS_DEFAULT_SETTINGS }
    let sectionContent = null
    let statusEl = null
    const inputsByKey = {}

    // Read-only view: the user is shown the current notification settings but cannot
    // change them here. Edits happen on the contact edit page (onContactPageMatch).
    const applySettingsToInputs = () => {
      NOTIFICATION_SETTING_DEFINITIONS.forEach((definition) => {
        const input = inputsByKey[definition.key]
        if (!input) return
        input.checked = Boolean(currentSettings[definition.key])
        input.disabled = true
        input.parentElement?.classList.add('is-readonly')
      })
    }

    const setStatusMessage = (message, { isError = false } = {}) => {
      if (!statusEl) return
      const hasMessage = Boolean(message)
      statusEl.textContent = message
      statusEl.classList.toggle('is-error', Boolean(isError))
      statusEl.style.display = hasMessage ? '' : 'none'
    }

    const buildAuthHeader = () => {
      try {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData?.token
        if (!token) return null
        return { Authorization: `Bearer ${token}` }
      } catch (error) {
        console.error('Error parsing auth from localStorage:', error)
        return null
      }
    }

    const loadSettings = async () => {
      const authHeader = buildAuthHeader()
      if (!authHeader) {
        setStatusMessage('Nicht angemeldet. Einstellungen können nicht geladen werden.', { isError: true })
        return
      }

      try {
        const response = await fetch(
          `${baseApiUrl}/api/notification-settings/contact/${currentContactId}`,
          {
            headers: { ...authHeader, 'Content-Type': 'application/json' },
            signal: abortController.signal,
          }
        )

        if (!response.ok) {
          setStatusMessage('Einstellungen konnten nicht geladen werden.', { isError: true })
          return
        }

        const data = await response.json()
        currentSettings = {
          ...NOTIFICATIONS_DEFAULT_SETTINGS,
          ...(data?.notificationSettings || {}),
        }

        if (!data?.isRegistered) {
          if (data?.email) {
            setStatusMessage(`Für ${data.email} ist kein Portal-Benutzer registriert.`)
          } else {
            setStatusMessage('Für diesen Kontakt ist kein Portal-Benutzer registriert.')
          }
        } else {
          setStatusMessage('')
        }

        applySettingsToInputs()
      } catch (error) {
        if (error?.name === 'AbortError') return
        console.error('Error loading notification settings:', error)
        setStatusMessage('Einstellungen konnten nicht geladen werden.', { isError: true })
      }
    }

    const buildSectionContent = () => {
      sectionContent = document.createElement('div')
      sectionContent.className = 'section-content'
      sectionContent.setAttribute('data-testid', `section-${NOTIFICATIONS_SECTION_ID}-content`)

      const body = document.createElement('div')
      body.className = 'impowerx-notifications-body'

      statusEl = document.createElement('div')
      statusEl.className = 'impowerx-notifications-status'
      statusEl.textContent = 'Lade Benachrichtigungseinstellungen...'
      body.append(statusEl)

      NOTIFICATION_SETTING_DEFINITIONS.forEach((definition) => {
        const row = document.createElement('div')
        row.className = `impowerx-notifications-row${definition.isChild ? ' is-child' : ''}`

        const label = document.createElement('label')
        label.className = 'impowerx-notifications-label'
        label.textContent = definition.label
        label.setAttribute('for', `impowerx-notifications-${definition.key}`)

        const switchWrapper = document.createElement('label')
        switchWrapper.className = 'impowerx-notifications-switch is-disabled'

        const input = document.createElement('input')
        input.type = 'checkbox'
        input.id = `impowerx-notifications-${definition.key}`
        input.dataset.notificationKey = definition.key
        input.disabled = true

        const slider = document.createElement('span')
        slider.className = 'impowerx-notifications-slider'

        switchWrapper.append(input, slider)
        row.append(label, switchWrapper)
        body.append(row)
        inputsByKey[definition.key] = input
      })

      sectionContent.append(body)
      sectionWrapper.appendChild(sectionContent)
    }

    sectionHeader.addEventListener('click', () => {
      const willOpen = sectionHeader.classList.contains('not-open')
      if (willOpen) {
        sectionHeader.classList.remove('not-open')
        sectionHeader.classList.add('open')
        sectionWrapper.classList.add('open')
        sectionNumberBox.classList.add('open')
        sectionTitleBox.classList.add('open')

        if (!sectionContent) {
          buildSectionContent()
          loadSettings()
        }
      } else {
        sectionHeader.classList.remove('open')
        sectionHeader.classList.add('not-open')
        sectionWrapper.classList.remove('open')
        sectionNumberBox.classList.remove('open')
        sectionTitleBox.classList.remove('open')
        if (sectionContent) {
          sectionContent.remove()
          sectionContent = null
          statusEl = null
          Object.keys(inputsByKey).forEach((key) => delete inputsByKey[key])
        }
      }
    })

    referenceSection.parentNode.insertBefore(section, referenceSection.nextSibling)
    return true
  }

  // Try immediately
  initializeSubstitutionSection()
  initEhepartnerViewSection()
  initPrivacyPolicySignedViewSection()
  initContactRolesViewSection()
  initContactOptionsViewSection()
  initTaxExemptionViewSection()
  initializeNotificationsSettingsSection()
  initKontaktierenViaDispatchPreferences({
    mode: 'view',
    getContactId: () => window.__impowerxPersonViewPersonId || null,
  })
  await injectPersonId()

  const isLuxPersonViewInjectNode = (node) => {
    if (!node || node.nodeType !== 1) return false
    return Boolean(
      node.closest?.(
        [
          '[data-impowerx-view-contact-options]',
          '[data-impowerx-view-tax-exemption]',
          '[data-impowerx-view-contact-substitution]',
          '[data-impowerx-view-ehepartner]',
          '[data-impowerx-view-privacy-policy-signed]',
          '[data-impowerx-view-contact-roles]',
          '.impowerx-data-injected-container',
          '#ImpowerxNotificationsSettingsSection',
          '[data-lux-kontaktieren-via]',
        ].join(', '),
      ) ||
        node.matches?.(
          [
            '[data-impowerx-view-contact-options]',
            '[data-impowerx-view-tax-exemption]',
            '[data-impowerx-view-contact-substitution]',
            '[data-impowerx-view-ehepartner]',
            '[data-impowerx-view-privacy-policy-signed]',
            '[data-impowerx-view-contact-roles]',
            '.impowerx-data-injected-container',
            '#ImpowerxNotificationsSettingsSection',
            '[data-lux-kontaktieren-via]',
          ].join(', '),
        ),
    )
  }

  // Observe DOM for dynamically loaded content (SPA).
  // Ignore mutations that only touch our own injects — otherwise
  // Kontaktieren-via / Weitere Kontaktmöglichkeiten re-trigger each other.
  let personViewInjectTimer = null
  const runPersonViewInjects = () => {
    injectPersonId()
    initializeSubstitutionSection()
    initEhepartnerViewSection()
    initPrivacyPolicySignedViewSection()
    initContactRolesViewSection()
    initContactOptionsViewSection()
    initTaxExemptionViewSection()
    initializeNotificationsSettingsSection()
    initKontaktierenViaDispatchPreferences({
      mode: 'view',
      getContactId: () => window.__impowerxPersonViewPersonId || null,
    })
  }

  const observer = new MutationObserver((mutations) => {
    const hasHostChange = mutations.some((mutation) => {
      const nodes = [...mutation.addedNodes, ...mutation.removedNodes]
      if (nodes.length === 0) return false
      return nodes.some((node) => node.nodeType === 1 && !isLuxPersonViewInjectNode(node))
    })
    if (!hasHostChange) return

    clearTimeout(personViewInjectTimer)
    personViewInjectTimer = setTimeout(runPersonViewInjects, 100)
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}
